import { Config } from './types';

export const prod: Config = {
  CONSENT_MANAGER_SCRIPT_URL:
    'https://d39xvdj9d5ntm1.cloudfront.net/common/static/consent-manager.js',
  HEAP_ID: '1155664863',
};
